import { sync } from 'vuex-router-sync'
import VueGtag from 'vue-gtag'
import './core/mixins'
import './core/dependencies'
import router from './plugins/vue-router'
import vuetify from '../plugins/vuetify'
import store from './store'
import App from './App.vue'
import axios from 'axios'
import './plugins/sentry'

sync(store, router)
window.store = store

if (navigator.serviceWorker) {
  navigator.serviceWorker.register('sw.js').then(registration => {
    registration.update()
  })
}

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      window.location = '/#/login'
    }
    return Promise.reject(error)
  }
)

Vue.use(VueGtag, {
  config: {
    id: EasyEvent.GTAG
  },
  bootstrap: false
}, router);

new Vue({
  store,
  i18n,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
